<template>
    <div class="h6">{{ $t('views.onboarding.title') }}: {{$t('common.step_1')}} 3/4</div>
    <h1 class="h2">{{ $t('views.onboarding.titles.3') }}</h1>
    <p class="p">{{ $t('views.onboarding.descriptions.3') }}</p>
    <TrackerSettings ref="tracker" :enableValidation="false" @update-status="updateStatus" />
    <div class="notice information" v-if="!status">{{ $t('views.onboarding.notices.skip_installation') }}</div>
</template>

<script>
    import TrackerSettings from '@/components/accountSettings/TrackerSettings';

    export default {
        name: 'OnboardingStep3',
        components: {
            TrackerSettings
        },
        data() {
            return {
                status: null,
            };
        },
        methods: {
            updateStatus(newStatus) {
                this.status = newStatus;
            },
        },
        mounted() {
            this.$nextTick(() => {
                this.stauts = this.$refs.tracker.status || null;
            });
        },
    }
</script>
